import React from 'react';
// ?raw 轉 data URI(理由同 MidAutumnEffect:內嵌模式 dev 的資源網址會 404)
import flagSvg from './flag.svg?raw';
import './DoubleTenEffect.scss';

const flagUrl = `data:image/svg+xml,${encodeURIComponent(flagSvg)}`;
const STRIPS = 12; // 國旗切成直條,各條錯開上下位移做出飄動感

const WavingFlag = ({ side }) => (
  <div className={`waving-flag waving-flag--${side}`}>
    <span className="flag-pole" />
    <div className="flag-cloth">
      {[...Array(STRIPS)].map((_, i) => (
        <span
          key={i}
          className="flag-strip"
          style={{
            backgroundImage: `url("${flagUrl}")`,
            // 第 i 條顯示整面旗的第 i 段(背景比容器寬時,i/(N-1) 的百分比剛好對齊)
            backgroundPosition: `${(i * 100) / (STRIPS - 1)}% 0`,
            animationDelay: `${-i * 0.12}s`,
          }}
        />
      ))}
    </div>
  </div>
);

/**
 * 雙十節特效 - 紅底 + 左右飄動國旗
 */
const DoubleTenEffect = () => {
  return (
    <div className="double-ten-effect" aria-hidden="true">
      <WavingFlag side="left" />
      <WavingFlag side="right" />
    </div>
  );
};

export default DoubleTenEffect;
